// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8dfc1654","453":"be2f06ae","455":"2d1f8aae"}[chunkId] + ".chunk.js";
};